/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { ActivityDetailResponse, GetActivitiesPaginatedResponse } from '../../app/features/activity/domain/activity.model';
import { ActivityDetailResponseMock } from '../dataMocks/activity-detail-response-mock';
import { activityPaginatedMock } from '../dataMocks/activity-mock';

@Injectable()
export class ActivityApiServiceMock {
    getActivityDetail(id: string): Observable<ActivityDetailResponse> {
        return of({ ...ActivityDetailResponseMock });
    }
    listVehicleActivities(page = 1, pageSize = 30, type: string | null, status: string | null): Observable<GetActivitiesPaginatedResponse> {
        return of({ ...activityPaginatedMock });
    }
}
